import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import Clients from "./Clients";
import js from "../assets/javascript.svg"
import ts from "../assets/typescript.svg";
import react from "../assets/react.svg";
import ruby from "../assets/ruby.svg";
import rails from "../assets/rails.svg";
import node from "../assets/node.svg";
import html from "../assets/html.svg";
import css from "../assets/css.svg";

function ClientsSection(props) {
  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={3}
          spaced={true}
          className="has-text-centered"
        ></SectionHeader>
        <Clients
          items={[
            {
              name: "JavaScript",
              image: js,
              width: "50px",
            },
            {
              name: "TypeScript",
              image: ts,
              width: "50px",
            },
            {
              name: "React",
              image: react,
              width: "50px",
            },
            {
              name: "Ruby",
              image: ruby,
              width: "50px",
            },
            {
              name: "Ruby on Rails",
              image: rails,
              width: "50px",
            },
            {
              name: "Node",
              image: node,
              width: "50px",
            },
            {
              name: "HTML",
              image: html, 
              width: "50px",
            },
            {
              name: "CSS",
              image: css,
              width: "50px",
            },
          ]}
        ></Clients>
      </div>
    </Section>
  );
}

export default ClientsSection;
